import React, { useState } from 'react';
import './ListPageSetup.css'; // 스타일링을 위한 CSS 파일을 임포트합니다.

const ListPageSetup = ({ onClose, sortOptions, sort, desc, rowsPerPage, total, setSort, setDesc, setRowsPerPage }) => {
  const [selectedSort, setSelectedSort] = useState(sort);
  const [selectedDesc, setSelectedDesc] = useState(desc);
  const [selectedRowsPerPage, setSelectedRowsPerPage] = useState(rowsPerPage);

  const handleSortChange = (value) => {
    setSelectedSort(value);
    setSort(value);
  };

  const handleDescChange = (value) => {
    setSelectedDesc(value);
    setDesc(value);
  };

  const handleRowsPerPageChange = (value) => {
    setSelectedRowsPerPage(value);
    setRowsPerPage(value);
  };

  return (
    <div id="list_page_setup">
      <div className="head">
        <h1>리스트 설정</h1>
        <button onClick={() => onClose()}>닫기</button>
      </div>
      <div className="body">
        <ul className="form">
          <li>
            <label>정렬 기준</label>
            <span>
              <select value={selectedSort} onChange={(e) => handleSortChange(e.target.value)}>
                <option value="">선택하세요</option>
                {sortOptions.map((option, index) => (
                  <option key={index} value={option.value} selected={sort === option.value}>
                    {option.name}
                  </option>
                ))}
              </select>
            </span>
          </li>
          <li>
            <label>정렬 방식</label>
            <span>
              <select value={selectedDesc} onChange={(e) => handleDescChange(e.target.value)}>
                <option value="">선택하세요</option>
                <option value="asc" selected={selectedDesc === "asc"}>정순</option>
                <option value="desc" selected={selectedDesc === "desc"}>역순</option>
              </select>
            </span>
          </li>
          <li>
            <label>페이지당 줄 수</label>
            <span>
              <input
                type="number"
                name="rowsPerPage"
                value={selectedRowsPerPage}
                onChange={(e) => handleRowsPerPageChange(Number(e.target.value))}
              />
              <button onClick={() => handleRowsPerPageChange(total)}>전체</button>
            </span>
          </li>
        </ul>
      </div>
      <div className="foot">
        <button onClick={() => onClose()}>닫기</button>
      </div>
    </div>
  );
};

export default ListPageSetup;